import { tns } from "tiny-slider";


export function textImageSlider() {
    let container   = '.js-text-image-items';
    let controls    = document.querySelector('.js-text-image-slider-controls');

    if(document.querySelector(container)) {
        let sliderElement = tns({
            container: container,
            items: 1,
            controls: true,
            nav: true,
            navPosition: 'bottom',
            controlsContainer: controls,
            mouseDrag: true,
            loop: false,
            gutter: 20,
            autoHeight: true
        });
    }

    return 'textImageSlider';
}
